/**
 * The payload carries its own hex colours, but they are a flat, saturated set
 * that reads as a different product next to this module's muted tokens. So the
 * known categories and statuses are painted from the design tokens here, and
 * the server's colours are kept only as the fallback for a key we have not
 * seen yet — a new category still renders without an FE release.
 */
export const CONSULTATION_SEGMENTS: Record<
  string,
  { color: string; tint: string }
> = {
  diet: { color: "var(--diet)", tint: "var(--jade-50)" },
  exercise: { color: "var(--exercise)", tint: "rgba(46, 125, 163, 0.1)" },
  success: { color: "var(--success)", tint: "#f3eef8" },
  doctor: { color: "var(--ink-2)", tint: "var(--surface-2)" },
  diagnostic: { color: "var(--warn)", tint: "#fbf4e7" },
};

/**
 * Status arrives as a display label ("MISSED"), not a key, so it is normalised
 * back to the class the stylesheet paints. Anything unrecognised keeps the
 * server's own colours.
 */
export const consultationStatusClass = (label?: string): string => {
  const key = (label || "").trim().toLowerCase().replace(/[\s_-]/g, "");

  if (key === "completed") return "completed";
  if (key === "scheduled" || key === "upcoming") return "scheduled";
  if (key === "cancelled" || key === "canceled") return "cancelled";
  if (key === "missed" || key === "noshow") return "noshow";
  return "";
};
